var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:({ color: _vm.statusColor })},[(_vm.statusIcon)?_c('fa-icon',{attrs:{"icon":['fas', _vm.statusIcon],"spin":_vm.spins,"title":_vm.status}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }